module.exports = __webpack_public_path__ + "img/81.42463a6d.jpg";